import debounce from 'lodash/debounce';

import notificationSound from '../sounds/notification.mp3';

const debounceNotificationSound = debounce(
  () => {
    const audio = new Audio(notificationSound);
    // An error is thrown when trying to auto play audio without having
    // interacted with the page yet. See: https://goo.gl/xX8pDD
    audio.play().catch(() => { /* ignore error */ });
  },
  1000,
  {
    leading: true,
    maxWait: 1000,
    trailing: false,
  },
);

export default debounceNotificationSound;
